var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"render-placeholder"},[_c('TTLoading')],1)}
var staticRenderFns = []

export { render, staticRenderFns }